import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconGrid1 = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M5.856 2.59c-.847.187-1.481.537-2.105 1.161a4.2 4.2 0 0 0-1.027 1.622l-.196.547v19.584l.149.48c.4 1.294 1.47 2.391 2.763 2.834l.416.142 9.696.018c8.71.016 9.743.007 10.162-.085 1.21-.267 2.302-1.137 2.852-2.273.172-.357.32-.774.361-1.02.049-.29.064-3.338.051-10.08l-.018-9.664-.142-.416c-.432-1.262-1.508-2.338-2.77-2.77l-.416-.142-9.696-.012c-7.855-.009-9.769.005-10.08.074m32.416.005c-1.463.318-2.756 1.585-3.138 3.075-.123.482-.126.744-.126 10.04 0 6.46.022 9.67.068 9.926.037.21.199.652.36.984.547 1.135 1.639 2.006 2.85 2.273.419.093 1.447.101 10.162.085l9.696-.018.416-.142c1.292-.443 2.362-1.54 2.763-2.834l.149-.48V5.92l-.196-.547c-.449-1.254-1.45-2.25-2.684-2.67l-.512-.175-9.696-.012c-8.138-.01-9.763.003-10.112.08M6.571 6.571c-.024.023-.043 4.157-.043 9.185V24.9l.164.063c.104.04 3.456.062 9.12.062 8.87 0 8.957-.001 9.084-.128s.128-.213.128-9.124c0-6.08-.021-9.037-.066-9.12-.065-.122-.236-.124-9.206-.124-5.026 0-9.158.02-9.181.043m32.471.08c-.045.084-.066 3.032-.066 9.12 0 8.912.001 8.998.128 9.125s.213.128 9.084.128c5.672 0 9.016-.023 9.12-.062l.164-.063-.016-9.17-.016-9.169-9.166-.016c-9.01-.016-9.166-.014-9.232.108M5.655 35.136c-1.402.367-2.536 1.465-2.977 2.881l-.15.48V58.08l.196.547c.449 1.254 1.45 2.25 2.684 2.67l.512.175h19.648l.448-.142c1.263-.4 2.363-1.488 2.802-2.77l.142-.416.018-9.664c.013-6.742-.002-9.79-.05-10.08-.042-.246-.19-.663-.362-1.02a4.25 4.25 0 0 0-2.749-2.246c-.48-.123-.742-.126-10.1-.123-9.173.004-9.626.01-10.062.124m32.503.002c-.743.195-1.32.534-1.91 1.122-.432.428-.572.622-.814 1.121-.172.357-.32.774-.361 1.02-.049.29-.064 3.338-.051 10.08l.018 9.664.142.416c.439 1.282 1.54 2.37 2.802 2.77l.448.142H58.08l.512-.175c1.234-.42 2.235-1.416 2.684-2.67l.196-.547V38.496l-.149-.48c-.4-1.294-1.47-2.392-2.763-2.834l-.416-.142-9.76-.013c-9.436-.013-9.776-.009-10.226.11m-31.6 3.983c-.017.044-.024 4.184-.014 9.2l.016 9.12 9.152.016c8.548.016 9.157.01 9.232-.092.105-.142.118-18.005.014-18.2-.065-.122-.236-.124-9.218-.124-7.263 0-9.158.017-9.182.08m32.484.044c-.104.195-.091 18.058.014 18.2.075.102.684.108 9.232.092l9.152-.016V39.072l-9.166-.016c-9.01-.016-9.166-.014-9.232.108" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconGrid1.displayName = 'IconGrid1';